import React, { useState, useContext } from "react";
import Header from "../components/Header";
import {
  Container,
  Card,
  Button,
  Form,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { FaEye, FaEyeSlash, FaWhatsapp } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import { AuthContext } from "../context/AuthContext";

const Login = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { loginUser } = useContext(AuthContext);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APP_URL}/login`,
        {
          phone_number: phoneNumber,
          password: password,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Platform": process.env.REACT_APP_X_PLATFORM,
            "API-Key": process.env.REACT_APP_API_KEY,
            "X-API-Version": process.env.REACT_APP_X_API_VERSION,
          },
          withCredentials: true,
        }
      );

      const { data } = response.data;
      const { access_token, user } = data;

      localStorage.setItem("token", access_token);
      localStorage.setItem("user", JSON.stringify(user));

      axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;

      loginUser(user);

      Swal.fire({
        icon: "success",
        title: "Login Successful!",
        text: "Redirecting to dashboard...",
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
      }).then(() => {
        const redirectPath = location.state?.from?.pathname || "/dashboard";
        navigate(redirectPath);
      });
    } catch (err) {
      console.error("Login error:", err);
      let errorMessage = "Terjadi kesalahan saat login.";

      if (err.response) {
        errorMessage =
          err.response.data.message ||
          err.response.data.errors ||
          "Login gagal dengan status " + err.response.status;
      } else if (err.request) {
        errorMessage = "Tidak ada respons dari server.";
      } else {
        errorMessage = err.message;
      }

      Swal.fire({
        icon: "error",
        title: "Login Gagal",
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Card style={{ width: "400px", padding: "20px" }}>
          <Card.Title className="text-center">{t("login")}</Card.Title>

          <Form onSubmit={handleLogin}>
            <Form.Group className="mb-3">
              <Form.Label>WhatsApp Number</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <FaWhatsapp
                    style={{ color: "#25D366", fontSize: "1.2rem" }}
                  />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="e.g. 081234567890"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  required
                />
              </InputGroup>
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>{t("password")}</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder={t("enterPassword")}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <InputGroup.Text
                  onClick={handleTogglePassword}
                  style={{ cursor: "pointer" }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>
            <div className="text-end mb-3">
              <Link
                to="/forgot-password"
                className="text-decoration-none text-muted"
              >
                Lupa Password?
              </Link>
            </div>

            <Button
              variant="success"
              type="submit"
              className="w-100"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Loading...
                </>
              ) : (
                t("login")
              )}
            </Button>
          </Form>

          <div className="text-center mt-3">
            <p>
              {t("noAccount")} <Link to="/register">{t("register")}</Link>
            </p>
          </div>
        </Card>
      </Container>
    </>
  );
};

export default Login;
